import React from 'react'

const CloseIcon = () => {
	return (
		<svg width={31} height={30} viewBox='0 0 31 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle
				cx={15.2132}
				cy={15}
				r={14.5}
				transform='rotate(-45 15.213 15)'
				stroke='currentColor'
			/>
			<path d='M9.24 21.241l12.022-12.02M8.82 9.18l12.02 12.021' stroke='currentColor' />
		</svg>
	)
}

export default CloseIcon
